export default function Footer() {
    return <footer className="footer text-center">
        For a more advanced version with many more features, check out the desktop application at <a rel="noreferrer" href="https://www.pictoselector.eu/" target="_blank">https://www.pictoselector.eu/</a>
        <br/>
        Ideas or suggestions? Send them to <a href="mailto:sander.ha@hotmail.com">sander.ha@hotmail.com</a>
    </footer>
}